import React from "react"
import Presentation from "./Presentation"

function Container(props) {
  return <Presentation {...props} />
}

export default Container
